import { useAuth } from '@sshop/auth';

/**
 * Re-exports the @sshop/auth context hook under the features layer so pages
 * import from `@/features/auth` instead of reaching into a shared package.
 */
export function useAuthSession() {
  return useAuth();
}
